/** Normalize human-entered hex, rejecting invalid pairs before numeric conversion. */
export function hexToBytes(hex: string): Uint8Array {
  if (typeof hex !== 'string') throw new Error('payload must be a hex string');
  const clean = hex.replace(/\s+/g, '').replace(/^0x/i, '');
  if (!clean.length) throw new Error('empty hex string');
  if (clean.length % 2 !== 0) throw new Error('odd hex length');
  if (!/^[0-9a-f]+$/i.test(clean)) throw new Error('non-hex character');
  return Uint8Array.from(clean.match(/../g)!, pair => parseInt(pair, 16));
}

/** Length determines the header format, as required by the family preamble. */
export function detectTier(bytes: Uint8Array): 0 | 1 | 2 {
  const tier = bytes.length === 51 ? 0 : bytes.length === 115 ? 1 : bytes.length === 222 ? 2 : undefined;
  if (tier === undefined) throw new Error(`Invalid payload length: ${bytes.length}; expected 51, 115, or 222 bytes`);
  const signature = tier === 0 ? [0x45, 0x4d] : [0x45, 0x4d, 0x52, 0x47, 0x31];
  if (!signature.every((byte, index) => bytes[index] === byte)) throw new Error('Unknown schema for payload length');
  if (tier > 0 && bytes[5] !== 0x10) throw new Error('Unsupported EMRG wire version; expected 0x10');
  return tier;
}
